import { type TicketStatus } from './tickets.schema';

// Map a backend error code to plain Romanian so raw codes (invalid_transition,
// not_found, ...) never reach a non-technical user. Falls back to a generic
// message rather than echoing the raw code.
export function ticketErrorRO(e: unknown, fallback = 'A aparut o eroare. Incearca din nou.'): string {
    const code = (e as { message?: string } | null)?.message;
    switch (code) {
        case 'invalid_transition':
        case 'invalid_status':
            return 'Aceasta mutare nu este permisa.';
        case 'not_found':
            return 'Ticketul nu mai exista.';
        case 'validation':
            return 'Date invalide.';
        case 'unauthorized':
            return 'Nu ai permisiunea pentru aceasta actiune.';
        default:
            return fallback;
    }
}

// A status change reads differently when it's the completion — give "done" its
// own celebratory copy instead of the generic "updated".
export function statusToastMessage(next: TicketStatus): string {
    return next === 'done' ? 'Gata! Ticketul e finalizat.' : 'Status actualizat.';
}
